import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var BulletsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M12.6668 21.9042H7.34582V27.2252H12.6668V21.9042Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40014 21.9042C6.40014 21.3819 6.82353 20.9585 7.34582 20.9585H12.6668C13.1891 20.9585 13.6125 21.3819 13.6125 21.9042V27.2252C13.6125 27.7475 13.1891 28.1709 12.6668 28.1709H7.34582C6.82353 28.1709 6.40014 27.7475 6.40014 27.2252V21.9042ZM8.29149 22.8498V26.2795H11.7211V22.8498H8.29149Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M10.1828 45.0543C11.7497 45.0543 13.0199 43.7841 13.0199 42.2173C13.0199 40.6504 11.7497 39.3803 10.1828 39.3803C8.616 39.3803 7.34582 40.6504 7.34582 42.2173C7.34582 43.7841 8.616 45.0543 10.1828 45.0543Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1828 40.3259C9.13828 40.3259 8.29149 41.1727 8.29149 42.2173C8.29149 43.2619 9.13828 44.1086 10.1828 44.1086C11.2274 44.1086 12.0742 43.2619 12.0742 42.2173C12.0742 41.1727 11.2274 40.3259 10.1828 40.3259ZM6.40014 42.2173C6.40014 40.1282 8.09371 38.4346 10.1828 38.4346C12.272 38.4346 13.9655 40.1282 13.9655 42.2173C13.9655 44.3064 12.272 46 10.1828 46C8.09371 46 6.40014 44.3064 6.40014 42.2173Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7202 4.2239V10.8839C8.7202 11.4062 9.14359 11.8296 9.66587 11.8296C10.1882 11.8296 10.6115 11.4062 10.6115 10.8839V3.28065C10.6115 2.3747 9.68436 1.72848 8.81634 2.11339C8.8167 2.11323 8.81598 2.11355 8.81634 2.11339L6.96338 2.93273C6.48571 3.14394 6.26971 3.70239 6.48092 4.18006C6.69213 4.65773 7.25058 4.87373 7.72825 4.66252L8.7202 4.2239Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0169 6.91205C17.0169 6.38977 17.4403 5.96637 17.9626 5.96637H40.6588C41.1811 5.96637 41.6045 6.38977 41.6045 6.91205C41.6045 7.43433 41.1811 7.85773 40.6588 7.85773H17.9626C17.4403 7.85773 17.0169 7.43433 17.0169 6.91205Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0169 24.5647C17.0169 24.0424 17.4403 23.619 17.9626 23.619H40.6588C41.1811 23.619 41.6045 24.0424 41.6045 24.5647C41.6045 25.087 41.1811 25.5103 40.6588 25.5103H17.9626C17.4403 25.5103 17.0169 25.087 17.0169 24.5647Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0169 42.2173C17.0169 41.695 17.4403 41.2716 17.9626 41.2716H40.6588C41.1811 41.2716 41.6045 41.695 41.6045 42.2173C41.6045 42.7396 41.1811 43.163 40.6588 43.163H17.9626C17.4403 43.163 17.0169 42.7396 17.0169 42.2173Z"
  }));
});
BulletsIcon.displayName = 'BulletsIcon';
BulletsIcon.defaultProps = {
  'aria-label': 'Bullets'
};
export default BulletsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/BulletsIcon/index.js
// module id = 1794
// module chunks = 12